import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getVehicletypes,
  vehicletypesListSuccessful,
  vehicletypesAddSuccessful,
  isModelVisible,
} from "./vehicletypesSlice";

// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";

function* getVehicletype({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/vehicletypes/", params);
    yield put(vehicletypesListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* AddVehicletypes({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/vehicletypes/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Vehicle Type Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getVehicletypes({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Vehicle Type. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(vehicletypesAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/vehicletypes/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Vehicle Type Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getVehicletypes({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Vehicle Type. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(vehicletypesAddSuccessful(null));
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteVehicletypes({ payload }) {
  var countryID = payload;
  try {
    const response = yield call(postDelete, "/masters/vehicletypes/" + countryID);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Vehicle Type has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getVehicletypes({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Vehicle Type has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

export function* watchgetVehicletypes() {
  yield takeEvery("vehicletypes/getVehicletypes", getVehicletype);
}
export function* watchVehicletypesAdd() {
  yield takeEvery("vehicletypes/vehicletypesAdd", AddVehicletypes);
}

export function* watchVehicletypesDelete() {
  yield takeEvery("vehicletypes/vehicletypesDelete", DeleteVehicletypes);
}

function* VehicletypesSaga() {
  yield all([fork(watchgetVehicletypes), fork(watchVehicletypesAdd), fork(watchVehicletypesDelete)]);
}

export default VehicletypesSaga;
